import React, { Component } from 'react'
import { Layout, Row, Col, Typography, Button, Upload } from 'antd'
import { Icon } from 'antd-mobile'
import { withTranslation } from 'react-i18next'
import BackupOutlinedIcon from '@material-ui/icons/BackupOutlined'
import ApiCaller from '../../utils/api-caller'

import './upload-test.css'

const { Content } = Layout
const { Text } = Typography

class UploadTestPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        };
    }

    componentDidMount() {
    }

    testUploadBackClicked = () => this.props.history.push('/')
    submitClicked = () => this.props.history.push('/')

    handleChange = info => {
        let fileList = [...info.fileList];

        // 1. Limit the number of uploaded files
        // Only to show two recent uploaded files, and old ones will be replaced by the new
        fileList = fileList.slice(-2);

        // 2. Read from response and show file link
        fileList = fileList.map(file => {
            if (file.status === 'done') {
                ApiCaller.Upload.apiUploadDocument(file.originFileObj, file.name).then(response => {
                })

                file.url = `https://s3-ap-east-1.amazonaws.com/staymenu-images/Documents/${file.name}`
            } 
            
            return file
        });

        this.setState({ fileList });
    };

    render() {
        const props = {
            action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            onChange: this.handleChange,
            multiple: false,
        };

        return (
            <Layout className='layout-page'>
                <Content>
                    <Row>
                        <Col span={24} className='col-header'>
                            <Row>
                                <Col span={4} className='col-header-back' onClick={this.testUploadBackClicked}>
                                    <Icon type='left' size='lg' color='#FFF' />
                                </Col>
                                <Col span={16} className='col-header-text'>
                                    <Text className='text-header'>Test Upload</Text>
                                </Col>
                                <Col span={4} />
                            </Row>
                        </Col>
                    </Row>
                    <Row className='row-body-content-uploadtest bg-white'>
                        <Col span={1} />
                        <Col span={22}>
                            <Row className='mg-b-10'>
                                <Col span={24} className='col-uploadtest-upload-container'>
                                    <Upload {...props} fileList={this.state.fileList}>
                                        <Button>
                                            <BackupOutlinedIcon /> Upload
                                        </Button>
                                    </Upload>
                                </Col>
                            </Row>

                            <Row className='mg-b-30'>
                                <Col span={24}>
                                    <Button className='btn-uploadtest-submit' onClick={this.submitClicked}> Upload
                                    </Button>
                                </Col>
                            </Row>

                        </Col>
                        <Col span={1} />
                    </Row>

                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(UploadTestPage)